
<div
	ref="toaster"
	class="flow-toaster"
	:style="styleObj"
	:data-state="state"
	:data-position="position"
	@mouseover="mouseover = true"
	@mouseleave="mouseover = false"
>
	<div class="flow-close-toaster" @click="remove()">
		<Icon name="i-close" type="filled" state="dark" size="xx-small" :effects="false" />
	</div>

	<slot />
</div>
